export default __webpack_public_path__ + "media/images/snow_tmp-02ab0bab1bffe354b336087ff7df7762.png";